<ng-container>
  <div class="organization-address-container pr-0 pl-0">
    <span class="organization-address-container__header">
      {{ "LABELS.BUSINESS_ADDRESS" | translate | uppercase }}

      <span class="d-lg-none">
        <app-hint-tooltip-icon [hint]="'LABELS.BUSINESS_ADDRESS_DESCRIPTION' | translate"></app-hint-tooltip-icon>
      </span>
    </span>
    <div class="d-flex" [formGroup]="formGroup">
      <div class="organization-address-container-form pr-0 pl-0 col-12 col-lg-8">
        <address-update
          [formGroup]="formGroup"
          [typeView]="enumTypeView.COMPANY"
          [isFilterRestrictedCountries]="true"
          [isAllowCountryDisable]="isDisableCountry"
          [isUnitedStates]="isUnitedStates"
          [errors]="errors"
        ></address-update>
      </div>
      <div class="d-none d-lg-block col-4">
        <div class="organization-address-container-description">
          <span>{{ "LABELS.BUSINESS_ADDRESS_DESCRIPTION" | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
